document.addEventListener('DOMContentLoaded', () => {
    const breadcrumbs = document?.querySelectorAll('.breadcrumb__active');
    function breadcrumbsShow(breadcrumbs) {
        const lastBreadcrumbs = Array.prototype.slice.call(breadcrumbs, breadcrumbs.length - 3);
        if (breadcrumbs.length > 3) {
            lastBreadcrumbs.at(0).innerHTML = '...<span class="breadcrumb__divider" aria-hidden="true">/</span>';
            lastBreadcrumbs.forEach(breadcrumb => breadcrumb.classList.add('show'));
        }
    }
    breadcrumbsShow(breadcrumbs);
});
